module.exports = __webpack_public_path__ + "img/EPBusinessBack4.44277e52.png";